'use strict'; // This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.

var raws = ['pre', 'script', 'style', 'textarea'];
module.exports = raws;